!function (e, t) {
    "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.VueWaves = t() : e.VueWaves = t()
}(this, function () {
    return function (e) {
        function t(r) {
            if (n[r])return n[r].exports;
            var o = n[r] = {exports: {}, id: r, loaded: !1};
            return e[r].call(o.exports, o, o.exports, t), o.loaded = !0, o.exports
        }

        var n = {};
        return t.m = e, t.c = n, t.p = "", t(0)
    }([function (e, t, n) {
        "use strict";
        function r(e) {
            return e && e.__esModule ? e : {"default": e}
        }

        n(5);
        var o = n(1), i = r(o);
        e.exports = {
            install: function (e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {name: "waves"};
                e.directive(t.name, {
                    inserted: function (e, t) {
                        var n = ["button", "circle", "block", "float", "light", "classic"].filter(function (e) {
                            return t.modifiers[e]
                        }).map(function (e) {
                            return "waves-" + e
                        });
                        i["default"].attach(e, n)
                    }
                }), e.mixin({
                    created: function () {
                        i["default"].init(t)
                    }
                })
            }
        }
    }, function (e, t, n) {
        var r, o;
        (function (n) {
            "use strict";
            var i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
                    return typeof e
                } : function (e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                };
            !function (n, i) {
                r = [], o = function () {
                    return i.apply(n)
                }.apply(t, r), !(void 0 !== o && (e.exports = o))
            }("object" === ("undefined" == typeof n ? "undefined" : i(n)) ? n : void 0, function () {
                function e(e) {
                    return null !== e && e === e.window
                }

                function t(t) {
                    return e(t) ? t : 9 === t.nodeType && t.defaultView
                }

                function n(e) {
                    var t = "undefined" == typeof e ? "undefined" : i(e);
                    return "function" === t || "object" === t && !!e
                }

                function r(e) {
                    return n(e) && e.nodeType > 0
                }

                function o(e) {
                    var t = p.call(e);
                    return "[object String]" === t ? f(e) : n(e) && /^\[object (Array|HTMLCollection|NodeList|Object)\]$/.test(t) && e.hasOwnProperty("length") ? e : r(e) ? [e] : []
                }

                function a(e) {
                    var n, r, o = {top: 0, left: 0}, a = e && e.ownerDocument;
                    return n = a.documentElement, "undefined" !== i(e.getBoundingClientRect) && (o = e.getBoundingClientRect()), r = t(a), {
                        top: o.top + r.pageYOffset - n.clientTop,
                        left: o.left + r.pageXOffset - n.clientLeft
                    }
                }

                function s(e) {
                    var t = "";
                    for (var n in e)e.hasOwnProperty(n) && (t += n + ":" + e[n] + ";");
                    return t
                }

                function u(e, t, n) {
                    if (n) {
                        n.classList.remove("waves-rippling");
                        var r = n.getAttribute("data-x"), o = n.getAttribute("data-y"), i = n.getAttribute("data-scale"), a = n.getAttribute("data-translate"), u = Date.now() - Number(n.getAttribute("data-hold")), l = 350 - u;
                        l < 0 && (l = 0), "mousemove" === e.type && (l = 150);
                        var c = "mousemove" === e.type ? 2500 : m.duration;
                        setTimeout(function () {
                            var e = {
                                top: o + "px",
                                left: r + "px",
                                opacity: "0",
                                "-webkit-transition-duration": c + "ms",
                                "-moz-transition-duration": c + "ms",
                                "-o-transition-duration": c + "ms",
                                "transition-duration": c + "ms",
                                "-webkit-transform": i + " " + a,
                                "-moz-transform": i + " " + a,
                                "-ms-transform": i + " " + a,
                                "-o-transform": i + " " + a,
                                transform: i + " " + a
                            };
                            n.setAttribute("style", s(e)), setTimeout(function () {
                                try {
                                    t.removeChild(n)
                                } catch (e) {
                                    return !1
                                }
                            }, c)
                        }, l)
                    }
                }

                function l(e) {
                    if (b.allowEvent(e) === !1)return null;
                    for (var t = null, n = e.target || e.srcElement; n.parentElement;) {
                        if (!(n instanceof SVGElement) && n.classList.contains("waves-effect")) {
                            t = n;
                            break
                        }
                        n = n.parentElement
                    }
                    return t
                }

                function c(e) {
                    var t = l(e);
                    if (null !== t) {
                        if (t.disabled || t.getAttribute("disabled") || t.classList.contains("disabled"))return;
                        if (b.registerEvent(e), "touchstart" === e.type && m.delay) {
                            var n = !1, r = setTimeout(function () {
                                r = null, m.show(e, t)
                            }, m.delay), o = function (o) {
                                r && (clearTimeout(r), r = null, m.show(e, t)), n || (n = !0, m.hide(o, t)), a()
                            }, i = function (e) {
                                r && (clearTimeout(r), r = null), o(e), a()
                            };
                            t.addEventListener("touchmove", i, !1), t.addEventListener("touchend", o, !1), t.addEventListener("touchcancel", o, !1);
                            var a = function () {
                                t.removeEventListener("touchmove", i), t.removeEventListener("touchend", o), t.removeEventListener("touchcancel", o)
                            }
                        } else m.show(e, t), v && (t.addEventListener("touchend", m.hide, !1), t.addEventListener("touchcancel", m.hide, !1)), t.addEventListener("mouseup", m.hide, !1), t.addEventListener("mouseleave", m.hide, !1)
                    }
                }

                var d = d || {}, f = document.querySelectorAll.bind(document), p = Object.prototype.toString, v = "ontouchstart" in window, m = {
                    duration: 750,
                    delay: 200,
                    show: function (e, t, n) {
                        if (2 === e.button)return !1;
                        t = t || this;
                        var r = document.createElement("div");
                        r.className = "waves-ripple waves-rippling", t.appendChild(r);
                        var o = a(t), i = 0, u = 0;
                        "touches" in e && e.touches.length ? (i = e.touches[0].pageY - o.top, u = e.touches[0].pageX - o.left) : (i = e.pageY - o.top, u = e.pageX - o.left), u = u >= 0 ? u : 0, i = i >= 0 ? i : 0;
                        var l = "scale(" + t.clientWidth / 100 * 3 + ")", c = "translate(0,0)";
                        n && (c = "translate(" + n.x + "px, " + n.y + "px)"), r.setAttribute("data-hold", Date.now()), r.setAttribute("data-x", u), r.setAttribute("data-y", i), r.setAttribute("data-scale", l), r.setAttribute("data-translate", c);
                        var d = {top: i + "px", left: u + "px"};
                        r.classList.add("waves-notransition"), r.setAttribute("style", s(d)), r.classList.remove("waves-notransition"), d["-webkit-transform"] = l + " " + c, d["-moz-transform"] = l + " " + c, d["-ms-transform"] = l + " " + c, d["-o-transform"] = l + " " + c, d.transform = l + " " + c, d.opacity = "1";
                        var f = "mousemove" === e.type ? 2500 : m.duration;
                        d["-webkit-transition-duration"] = f + "ms", d["-moz-transition-duration"] = f + "ms", d["-o-transition-duration"] = f + "ms", d["transition-duration"] = f + "ms", r.setAttribute("style", s(d))
                    },
                    hide: function (e, t) {
                        t = t || this;
                        for (var n = t.getElementsByClassName("waves-rippling"), r = 0, o = n.length; r < o; r++)u(e, t, n[r]);
                        v && (t.removeEventListener("touchend", m.hide), t.removeEventListener("touchcancel", m.hide)), t.removeEventListener("mouseup", m.hide), t.removeEventListener("mouseleave", m.hide)
                    }
                }, h = {
                    input: function (e) {
                        var t = e.parentNode;
                        if ("i" !== t.tagName.toLowerCase() || !t.classList.contains("waves-effect")) {
                            var n = document.createElement("i");
                            n.className = e.className + " waves-input-wrapper", e.className = "waves-button-input", t.replaceChild(n, e), n.appendChild(e);
                            var r = window.getComputedStyle(e, null), o = r.color, i = r.backgroundColor;
                            n.setAttribute("style", "color:" + o + ";background:" + i), e.setAttribute("style", "background-color:rgba(0,0,0,0);")
                        }
                    }, img: function (e) {
                        var t = e.parentNode;
                        if ("i" !== t.tagName.toLowerCase() || !t.classList.contains("waves-effect")) {
                            var n = document.createElement("i");
                            t.replaceChild(n, e), n.appendChild(e)
                        }
                    }
                }, b = {
                    touches: 0, allowEvent: function (e) {
                        var t = !0;
                        return /^(mousedown|mousemove)$/.test(e.type) && b.touches && (t = !1), t
                    }, registerEvent: function (e) {
                        var t = e.type;
                        "touchstart" === t ? b.touches += 1 : /^(touchend|touchcancel)$/.test(t) && setTimeout(function () {
                                b.touches && (b.touches -= 1)
                            }, 500)
                    }
                };
                return d.init = function (e) {
                    var t = document.body;
                    e = e || {}, "duration" in e && (m.duration = e.duration), "delay" in e && (m.delay = e.delay), v && (t.addEventListener("touchstart", c, !1), t.addEventListener("touchcancel", b.registerEvent, !1), t.addEventListener("touchend", b.registerEvent, !1)), t.addEventListener("mousedown", c, !1)
                }, d.attach = function (e, t) {
                    e = o(e), "[object Array]" === p.call(t) && (t = t.join(" ")), t = t ? " " + t : "";
                    for (var n, r, i = 0, a = e.length; i < a; i++)n = e[i], r = n.tagName.toLowerCase(), ["input", "img"].indexOf(r) !== -1 && (h[r](n), n = n.parentElement), n.className.indexOf("waves-effect") === -1 && (n.className += " waves-effect" + t)
                }, d.ripple = function (e, t) {
                    e = o(e);
                    var n = e.length;
                    if (t = t || {}, t.wait = t.wait || 0, t.position = t.position || null, n)for (var r, i, s, u = {}, l = 0, c = {
                        type: "mousedown",
                        button: 1
                    }, d = function (e, t) {
                        return function () {
                            m.hide(e, t)
                        }
                    }; l < n; l++)if (r = e[l], i = t.position || {
                                x: r.clientWidth / 2,
                                y: r.clientHeight / 2
                            }, s = a(r), u.x = s.left + i.x, u.y = s.top + i.y, c.pageX = u.x, c.pageY = u.y, m.show(c, r), t.wait >= 0 && null !== t.wait) {
                        var f = {type: "mouseup", button: 1};
                        setTimeout(d(f, r), t.wait)
                    }
                }, d.calm = function (e) {
                    e = o(e);
                    for (var t = {type: "mouseup", button: 1}, n = 0, r = e.length; n < r; n++)m.hide(t, e[n])
                }, d.displayEffect = function (e) {
                    console.error("Waves.displayEffect() has been deprecated and will be removed in future version. Please use Waves.init() to initialize Waves effect"), d.init(e)
                }, d
            })
        }).call(t, function () {
            return this
        }())
    }, function (e, t, n) {
        t = e.exports = n(3)(), t.push([e.id, "/*!\n * Waves v0.7.5\n * http://fian.my.id/Waves \n * \n * Copyright 2014-2016 Alfiana E. Sibuea and other contributors \n * Released under the MIT license \n * https://github.com/fians/Waves/blob/master/LICENSE \n */.waves-effect{position:relative;cursor:pointer;display:inline-block;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}.waves-effect .waves-ripple{position:absolute;border-radius:50%;width:100px;height:100px;margin-top:-50px;margin-left:-50px;opacity:0;background:rgba(0,0,0,.2);background:-webkit-radial-gradient(rgba(0,0,0,.2) 0,rgba(0,0,0,.3) 40%,rgba(0,0,0,.4) 50%,rgba(0,0,0,.5) 60%,hsla(0,0%,100%,0) 70%);background:radial-gradient(rgba(0,0,0,.2) 0,rgba(0,0,0,.3) 40%,rgba(0,0,0,.4) 50%,rgba(0,0,0,.5) 60%,hsla(0,0%,100%,0) 70%);-webkit-transition:all .5s ease-out;transition:all .5s ease-out;-webkit-transition-property:-webkit-transform,opacity;transition-property:transform,opacity;-webkit-transform:scale(0) translate(0);transform:scale(0) translate(0);pointer-events:none}.waves-effect.waves-light .waves-ripple{background:hsla(0,0%,100%,.4);background:-webkit-radial-gradient(hsla(0,0%,100%,.2) 0,hsla(0,0%,100%,.3) 40%,hsla(0,0%,100%,.4) 50%,hsla(0,0%,100%,.5) 60%,hsla(0,0%,100%,0) 70%);background:radial-gradient(hsla(0,0%,100%,.2) 0,hsla(0,0%,100%,.3) 40%,hsla(0,0%,100%,.4) 50%,hsla(0,0%,100%,.5) 60%,hsla(0,0%,100%,0) 70%)}.waves-effect.waves-classic .waves-ripple{background:rgba(0,0,0,.2)}.waves-effect.waves-classic.waves-light .waves-ripple{background:hsla(0,0%,100%,.4)}.waves-notransition{-webkit-transition:none!important;transition:none!important}.waves-button,.waves-circle{-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-mask-image:-webkit-radial-gradient(circle,#fff 100%,#000 0)}.waves-button,.waves-button-input,.waves-button:hover,.waves-button:visited{white-space:nowrap;vertical-align:middle;cursor:pointer;border:none;outline:none;color:inherit;background-color:transparent;font-size:1em;line-height:1em;text-align:center;text-decoration:none;z-index:1}.waves-button{padding:.85em 1.1em;border-radius:.2em}.waves-button-input{margin:0;padding:.85em 1.1em}.waves-input-wrapper{border-radius:.2em;vertical-align:bottom}.waves-input-wrapper.waves-button{padding:0}.waves-input-wrapper .waves-button-input{position:relative;top:0;left:0;z-index:1}.waves-circle{text-align:center;width:2.5em;height:2.5em;line-height:2.5em;border-radius:50%}.waves-float{-webkit-mask-image:none;box-shadow:0 1px 1.5px 1px rgba(0,0,0,.12);-webkit-transition:all .3s;transition:all .3s}.waves-float:active{box-shadow:0 8px 20px 1px rgba(0,0,0,.3)}.waves-block{display:block}", ""])
    }, function (e, t) {
        e.exports = function () {
            var e = [];
            return e.toString = function () {
                for (var e = [], t = 0; t < this.length; t++) {
                    var n = this[t];
                    n[2] ? e.push("@media " + n[2] + "{" + n[1] + "}") : e.push(n[1])
                }
                return e.join("")
            }, e.i = function (t, n) {
                "string" == typeof t && (t = [[null, t, ""]]);
                for (var r = {}, o = 0; o < this.length; o++) {
                    var i = this[o][0];
                    "number" == typeof i && (r[i] = !0)
                }
                for (o = 0; o < t.length; o++) {
                    var a = t[o];
                    "number" == typeof a[0] && r[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"), e.push(a))
                }
            }, e
        }
    }, function (e, t, n) {
        function r(e, t) {
            for (var n = 0; n < e.length; n++) {
                var r = e[n], o = p[r.id];
                if (o) {
                    o.refs++;
                    for (var i = 0; i < o.parts.length; i++)o.parts[i](r.parts[i]);
                    for (; i < r.parts.length; i++)o.parts.push(l(r.parts[i], t))
                } else {
                    for (var a = [], i = 0; i < r.parts.length; i++)a.push(l(r.parts[i], t));
                    p[r.id] = {id: r.id, refs: 1, parts: a}
                }
            }
        }

        function o(e) {
            for (var t = [], n = {}, r = 0; r < e.length; r++) {
                var o = e[r], i = o[0], a = o[1], s = o[2], u = o[3], l = {css: a, media: s, sourceMap: u};
                n[i] ? n[i].parts.push(l) : t.push(n[i] = {id: i, parts: [l]})
            }
            return t
        }

        function i(e, t) {
            var n = h(), r = w[w.length - 1];
            if ("top" === e.insertAt) r ? r.nextSibling ? n.insertBefore(t, r.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), w.push(t); else {
                if ("bottom" !== e.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
                n.appendChild(t)
            }
        }

        function a(e) {
            e.parentNode.removeChild(e);
            var t = w.indexOf(e);
            t >= 0 && w.splice(t, 1)
        }

        function s(e) {
            var t = document.createElement("style");
            return t.type = "text/css", i(e, t), t
        }

        function u(e) {
            var t = document.createElement("link");
            return t.rel = "stylesheet", i(e, t), t
        }

        function l(e, t) {
            var n, r, o;
            if (t.singleton) {
                var i = g++;
                n = b || (b = s(t)), r = c.bind(null, n, i, !1), o = c.bind(null, n, i, !0)
            } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (n = u(t), r = f.bind(null, n), o = function () {
                    a(n), n.href && URL.revokeObjectURL(n.href)
                }) : (n = s(t), r = d.bind(null, n), o = function () {
                    a(n)
                });
            return r(e), function (t) {
                if (t) {
                    if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap)return;
                    r(e = t)
                } else o()
            }
        }

        function c(e, t, n, r) {
            var o = n ? "" : r.css;
            if (e.styleSheet) e.styleSheet.cssText = y(t, o); else {
                var i = document.createTextNode(o), a = e.childNodes;
                a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(i, a[t]) : e.appendChild(i)
            }
        }

        function d(e, t) {
            var n = t.css, r = t.media;
            if (r && e.setAttribute("media", r), e.styleSheet) e.styleSheet.cssText = n; else {
                for (; e.firstChild;)e.removeChild(e.firstChild);
                e.appendChild(document.createTextNode(n))
            }
        }

        function f(e, t) {
            var n = t.css, r = t.sourceMap;
            r && (n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(r)))) + " */");
            var o = new Blob([n], {type: "text/css"}), i = e.href;
            e.href = URL.createObjectURL(o), i && URL.revokeObjectURL(i)
        }

        var p = {}, v = function (e) {
            var t;
            return function () {
                return "undefined" == typeof t && (t = e.apply(this, arguments)), t
            }
        }, m = v(function () {
            return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase())
        }), h = v(function () {
            return document.head || document.getElementsByTagName("head")[0]
        }), b = null, g = 0, w = [];
        e.exports = function (e, t) {
            t = t || {}, "undefined" == typeof t.singleton && (t.singleton = m()), "undefined" == typeof t.insertAt && (t.insertAt = "bottom");
            var n = o(e);
            return r(n, t), function (e) {
                for (var i = [], a = 0; a < n.length; a++) {
                    var s = n[a], u = p[s.id];
                    u.refs--, i.push(u)
                }
                if (e) {
                    var l = o(e);
                    r(l, t)
                }
                for (var a = 0; a < i.length; a++) {
                    var u = i[a];
                    if (0 === u.refs) {
                        for (var c = 0; c < u.parts.length; c++)u.parts[c]();
                        delete p[u.id]
                    }
                }
            }
        };
        var y = function () {
            var e = [];
            return function (t, n) {
                return e[t] = n, e.filter(Boolean).join("\n")
            }
        }()
    }, function (e, t, n) {
        var r = n(2);
        "string" == typeof r && (r = [[e.id, r, ""]]);
        n(4)(r, {});
        r.locals && (e.exports = r.locals)
    }])
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-waves-button/index.js
// module id = 8gT5
// module chunks = 0